<p-autoComplete
  class="event-search"
  [style]="{ width: '100%' }"
  [inputStyle]="{ width: '100%' }"
  [formControl]="searchControl"
  [suggestions]="(eventSuggestions$ | async) ?? []"
  (onSelect)="openEvent($event.value)"
  (completeMethod)="handleCompletMethod($event)"
  placeholder="Buscar eventos"
  emptyMessage="Nenhum resultado encontrado">
  <ng-template let-event pTemplate="item">
    <div class="event-item">
      <img class="event-item__banner" [src]="loadEventImage(event.thumbnail)" alt="{{ event.title }}" loading="lazy" />

      <div class="event-item__content">
        <div class="event-item__header">
          <span class="event-item__title">{{ event.title }}</span>

          @if (event.event_category?.title) {
            <span class="badge badge--muted">
              {{ event.event_category.title }}
            </span>
          }
        </div>

        <div class="event-item__meta">
          <div class="event-item__meta-row">
            <i class="pi pi-calendar"></i>
            <span>{{ event.start_date | date: "dd/MM/yyyy" }}</span>
            <span>{{ event.start_date | date: "HH:mm" }}</span>
          </div>

          <div class="event-item__meta-row">
            <i class="pi pi-map-marker"></i>
            <span class="event-item__location">
              {{ event.address?.location_name }}
              — {{ event.address?.city_name }} / {{ event.address?.state }}
            </span>
          </div>

          <div class="event-item__meta-row">
            <i class="pi pi-user"></i>
            <span class="event-item__organizer">{{ event.organizer_name }}</span>
          </div>
        </div>
      </div>
    </div>
  </ng-template>
</p-autoComplete>
